import styled from "styled-components";

export const Wrapper = styled.div`
    

`
export const NameWrapper = styled.div`
display: flex;
justify-content: start;
align-items: center;
flex-direction: row;
span{
    padding-left: 10px;
}
`
export const TableFilter = styled.div`
display: flex;
justify-content: start;
align-items: baseline;
flex-direction: row;
width: 32%;
padding: 15px;
span{
    font-size: 18px;
    font-weight: bold;
    color: #2555EF;
    padding-right: 20px;
}
`
export const Title = styled.div`
    font-size: 18px !important;
    color: #0c2e5c !important;
    font-weight: 600 !important;
    padding: 30px;
`